import { useTranslation } from "../context/TranslationContext";
import Icon from "./ds/Icon";

/** How Mintly keeps bots out of Creator Rewards — a section of About us (Figma "Trust & Safety"). */
const BotProtectionSection = () => {
  const { t } = useTranslation();

  const cards = [
    ["eye", t("botProtection.cardMonitorTitle"), t("botProtection.cardMonitorBody")],
    ["warning", t("botProtection.cardDetectTitle"), t("botProtection.cardDetectBody")],
    ["lock", t("botProtection.cardEnforceTitle"), t("botProtection.cardEnforceBody")],
    ["check-circle", t("botProtection.cardFairTitle"), t("botProtection.cardFairBody")],
  ];

  return (
    <div className="grid grid-cols-1 gap-space-24 rounded-radius-lg bg-bg-raised p-space-24 lg:grid-cols-2 lg:gap-space-48 lg:p-space-40">
      <div className="flex flex-col gap-space-12">
        <p className="text-caps-label uppercase text-accent-text">{t("botProtection.eyebrow")}</p>
        <h2 className="text-title-1 text-label-primary">{t("botProtection.title")}</h2>
        {[t("botProtection.p1"), t("botProtection.p2"), t("botProtection.p3"), t("botProtection.p4")].map((text) => (
          <p key={text} className="text-subheadline text-label-secondary">
            {text}
          </p>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-space-16 min-[600px]:grid-cols-2 lg:gap-space-24">
        {cards.map(([icon, title, body]) => (
          <div key={title} className="flex flex-col gap-space-8 rounded-radius-lg bg-fill-quaternary p-space-16">
            <Icon name={icon} size={20} className="text-accent-text" />
            <h3 className="text-headline text-label-primary">{title}</h3>
            <p className="text-footnote text-label-secondary">{body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BotProtectionSection;
